import AirModal from "./AirModal"
export default  AirModal;



// WEBPACK FOOTER //
// ./src/commonComponents/AirModal/index.js